export const CALENDAR_TOOLBAR_VIEWPORT_PADDING_PX = 8;

export interface CalendarToolbarAnchorRect {
  top: number;
  left: number;
  right: number;
  height: number;
}

export interface CalendarToolbarSize {
  width: number;
  height: number;
}

export interface CalendarToolbarViewport {
  width: number;
  height: number;
}

export interface CalendarToolbarPosition {
  top: number;
  left: number;
  side: "left" | "right";
}

/**
 * Positions the calendar action toolbar beside its block in viewport space.
 * The right side is preferred; when it cannot fit, the toolbar flips left.
 * Vertical placement is clamped so short or edge-adjacent blocks do not push
 * the toolbar outside the viewport.
 */
export function computeCalendarToolbarPosition(
  anchor: CalendarToolbarAnchorRect,
  toolbar: CalendarToolbarSize,
  viewport: CalendarToolbarViewport,
  padding = CALENDAR_TOOLBAR_VIEWPORT_PADDING_PX,
): CalendarToolbarPosition {
  const maxTop = Math.max(padding, viewport.height - toolbar.height - padding);
  const top = Math.min(
    Math.max(anchor.top + anchor.height / 2 - toolbar.height / 2, padding),
    maxTop,
  );

  if (anchor.right + toolbar.width <= viewport.width - padding) {
    return { top, left: anchor.right, side: "right" };
  }

  return {
    top,
    left: Math.max(padding, anchor.left - toolbar.width),
    side: "left",
  };
}
